import { styled } from '@mui/styles';
import {
  useTheme,
  Box,
  TooltipProps,
  tooltipClasses,
  Tooltip,
  lighten,
} from '@mui/material';
import { EventContentArg } from '@fullcalendar/react';
//import { CommitmentDetail } from '../ccf-commitment/ccf-commitment-details';
import ccfCommitmentStyles from '../ccf-commitment/ccf-commitment-form.styles';


/**
 * custom component for event
 * @returns component for rendering the event with tooltip
 * @example useCcfApScheduleContent
 */
export const useCcfAppScheduleContent = () => {
  const theme = useTheme();
  const styles = ccfCommitmentStyles(theme);

   /**
   * custom component for event
   * @returns component for rendering the event with tooltip
   * @example CcfAppScheduleContent
   */
   const formatAMPM = (date : any) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();    
    const ampm = hours >= 12 ? 'pm' : 'am';
  
    hours %= 12;
    hours = hours || 12;    
    minutes = minutes < 10 ? `0${minutes}` : minutes;
  
    const strTime = `${hours}:${minutes} ${ampm}`;
  
    return strTime;
  };

  /**
   * custom component for event
   * @returns component for rendering the event with tooltip
   * @example CcfAppScheduleContent
   */
  const getCcfAppScheduleContent = (eventArgs: EventContentArg) => {
    const { timeText, backgroundColor } = eventArgs;
    const { title, start, end, display } = eventArgs.event;

    const { isWEMEvent, borderHighlightColor } =
      eventArgs.event?._def?.extendedProps || {};

    if (display === 'background') {
      return title && <Box sx={styles.fcEventTitle}>{title}</Box>;
    }

    // const CommitmentTooltip = styled(
    //   ({ className, ...props }: TooltipProps) => (
    //     <Tooltip {...props} classes={{ popper: className }} />
    //   )
    // )(({ theme: Theme }) =>
    //   isWEMEvent
    //     ? {}
    //     : {
    //         [`& .${tooltipClasses.tooltip}`]: {
    //           backgroundColor: theme?.palette?.background?.paper,
    //           color: 'black',
    //           fontSize: '14px',
    //           border: '1px solid #dde4e9',
    //         },
    //       }
    // );

    return (
      // <CommitmentTooltip
      //   title={
      //     isWEMEvent ? (
      //       `${title}  ${timeText}`
      //     ) : (
      //       <CommitmentDetail eventArgs={eventArgs} />
      //     )
      //   }
      //   PopperProps={{
      //     sx: isWEMEvent || styles.tooltipArrow,
      //   }}
      //   placement="top"
      //   arrow
      //   aria-label={`${title} ${timeText}`}
      // >
        <Box
          component="div"
          sx={{
            ...styles.fcEventMainFrame,
            backgroundColor: lighten(backgroundColor, 1),
          }}
        >
          {!title.includes('-') ? (
            <Box
              component="div"
              sx={{
                width: { xs: '4%', md: '3%', lg: '2%', xl: '1.5%' },
                backgroundColor: !isWEMEvent ? '#ffb000' : borderHighlightColor,
                ...styles.fcEventMainFrameBorder,
              }}
            />
          ) : null}
          <Box sx={styles.fcEventTitleContainer}>
            <Box sx={{ ...styles.fcEventTitle, ...styles.fcSticky }}>
              {title || <>&nbsp;</>}
            </Box>
            <Box sx={{ ...styles.fcEventTitle, ...styles.fcSticky }}>
            {formatAMPM(start)}{" - "}{formatAMPM(end)}
            </Box>
          </Box>
        </Box>
    //  </CommitmentTooltip>
    );
  };

  return { getCcfAppScheduleContent };
};